export var LOCAL_STORAGE_KEYS = {
    themeMode: 'themeMode',
    languageMode: 'languageMode'
};
export var ID_NUMBER_LENGTH = 10;
export var RSA_FRONTEND_MW_PUBLIC_KEY = '-----BEGIN PUBLIC KEY-----MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC8AX++RtxPZFtns4XzXFlDIxPBh0umN4qRXZaKDIlb6a3MknaB7psJWmf2l+e4Cfh9b5tey/+rZqpQ065eXTZfGCAuBLt+fYLQBhLfjRpk8S6hlIzc1Kdjg65uqzMwcTd0p7I4KLwHk1I0oXzuEu53fU1LSZhWp4Mnd6wjVgXAsQIDAQAB-----END PUBLIC KEY-----';
